"use client";

import { PropsWithChildren } from "react";
import { GlobalStyle } from "@/theme/global-style";
import { ThemeProvider } from "@/theme/theme-provider";
import StyledComponentsRegistry from "@/lib/registry";
import { ModalProvider } from "./modal-provider";
import { NotificationProvider } from "./notification-provider";
import { AnalyticsProvider } from "./analytics-provider";
import styled from "styled-components";
import Script from "next/script";

import * as snippet from "@segment/snippet";
import { ToastProvider } from "./toast-provider";
import { FlagProvider } from "@unleash/proxy-client-react";
import { unleashConfig } from "@/lib/unleash";

const DisableTextSelection = styled.div`
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  height: 100%;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: unset;
  }
`;

export function Providers({ children }: PropsWithChildren) {
  const loadSegment = () => {
    const options = {
      apiKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
      // disable automatic page view
      page: false,
    };
    return snippet.max(options);
  };

  return (
    <DisableTextSelection>
      <Script
        dangerouslySetInnerHTML={{ __html: loadSegment() }}
        id="segmentScript"
      />
      <StyledComponentsRegistry>
        <ThemeProvider>
        <FlagProvider config={unleashConfig}>
          <ToastProvider>
            <GlobalStyle />
            <AnalyticsProvider>
              <ModalProvider>
                <NotificationProvider>{children}</NotificationProvider>
              </ModalProvider>
            </AnalyticsProvider>
          </ToastProvider>
        </FlagProvider>
        </ThemeProvider>
      </StyledComponentsRegistry>
    </DisableTextSelection>
  );
}
